<template>
  <div class="orderListSon">
    <el-card class="box-card">
      <div slot="header" style="display:flex;align-items: center;justify-content: space-between;">
        <div style="display:flex;align-items:center;">
          <i @click="onBack" class="el-icon-arrow-left" style="font-size:25px;"></i>
          <span style="font-size:25px;font-weight:bold;margin:0 10px;">{{ h_text }}</span>
        </div>
        <el-button @click="copyOrderInfo" type="primary" size="small" icon="el-icon-document-copy">复制订单信息
        </el-button>
      </div>
      <div
          style="display: flex;flex-flow: column;width:100%;padding:10px 0;align-items: center;justify-content: center">
        <el-steps
            :active="activeStep"
            :space="200"
            style="width:800px;"
            finish-status="primary"
            class="custom-steps">

          <el-step v-for="(d,index) in liState" :key="`zf${index}`"
                   :title="d.label"
                   :icon="d.icon"
                   class="step-item">
            <div slot="description" class="step-time">{{ d.description }}</div>
          </el-step>
        </el-steps>
      </div>
      <div style="height:auto;width:100%;display:flex;background:#F4F4F4;padding:0.5% 0">
        <div
            style="width:50%;background:#FFFFFF;margin-left:0.5%;display: flex;flex-flow: column;padding-left:15px;padding-bottom:20px;">
          <p style="font-size:20px;font-weight:bold;margin-top:10px;margin-bottom:5px">基本订单信息</p>
          <div style="display:flex;align-items:center">
            <p style="margin:0">订单编号</p>
            <p style="margin:0 0 0 10px">{{ d_info.id || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">订单类型</p>
            <p style="margin:0 0 0 10px">{{ d_info.orderTypeName || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">订单状态</p>
            <p style="margin:0 0 0 10px">{{ d_info.orderStatusName || "" }}</p>
          </div>
          <!--          <div style="display:flex;align-items:center">
                      <p style="margin:0">订单来源</p>
                      <p style="margin:0 0 0 10px">{{ d_info.orderStatusName || "" }}</p>
                    </div>-->
          <div style="display:flex;align-items:center">
            <p style="margin:0">订单空间</p>
            <p style="margin:0 0 0 10px">{{ d_info.roomName || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">下单时间</p>
            <p style="margin:0 0 0 10px">{{ d_info.times || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">支付流水号</p>
            <p style="margin:0 0 0 10px">{{ d_info.transactionId || "" }}</p>
          </div>
          <!--          <div style="display:flex;align-items:center">-->
          <!--            <p style="margin:0">支付方式</p>-->
          <!--            <p style="margin:0 0 0 10px">{{ d_info.transactionId || "" }}</p>-->
          <!--          </div>-->
          <div style="display:flex;align-items:center">
            <p style="margin:0">手机号</p>
            <p style="margin:0 0 0 10px">{{ d_info.phoneNumber || "" }}</p>
          </div>
          <!--          <div style="display:flex;align-items:center">
                      <p style="margin:0">支付时间</p>
                      <p style="margin:0 0 0 10px">{{ d_info.phoneNumber || "" }}</p>
                    </div>-->
          <div style="display:flex;align-items:center">
            <p style="margin:0">订单金额</p>
            <p style="margin:0 0 0 10px">¥{{ d_info.money.toFixed(2) || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">实付金额</p>
            <p style="margin:0 0 0 10px">¥{{ d_info.moneyPaid.toFixed(2) || "" }}</p>
          </div>
          <!--          <div style="display:flex;align-items:center">
                      <p style="margin:0">优惠劵抵扣</p>
                      <p style="margin:0 0 0 10px">15</p>
                    </div>
                    <div style="display:flex;align-items:center">
                      <p style="margin:0">优惠劵名称</p>
                      <p style="margin:0 0 0 10px">15</p>
                    </div>
                    <div style="display:flex;align-items:center;margin-bottom: 5px">
                      <p style="margin:0">优惠劵编码</p>
                      <p style="margin:0 0 0 10px">15</p>
                    </div>-->
          <div style="height: 1px;margin: 6px 0;background: #409EFF"></div>
          <p style="font-size:20px;font-weight:bold;margin-top:5px;margin-bottom:5px">用户信息</p>
          <div style="display:flex;align-items:center">
            <p style="margin:0">用户名称</p>
            <p style="margin:0 0 0 10px">{{ d_info.userName || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">手机号码</p>
            <p style="margin:0 0 0 10px">{{ d_info.phoneNumber || "" }}</p>
          </div>
        </div>
        <div
            style="width:50%;background:#FFFFFF;margin-left:0.5%;display: flex;flex-flow: column;padding-left:15px;padding-bottom:20px;">
          <p style="font-size:20px;font-weight:bold;margin-top:10px;margin-bottom:5px">预约信息</p>
          <div style="display:flex;align-items:center">
            <p style="margin:0">预约单号</p>
            <p style="margin:0 0 0 10px">{{ d_info.appId || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">预约空间</p>
            <p style="margin:0 0 0 10px">{{ d_info.roomName || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">预约时间</p>
            <p style="margin:0 0 0 10px">{{ d_info.appTime || "" }}</p>
          </div>
          <div style="display:flex;align-items:center">
            <p style="margin:0">预约备注</p>
            <p style="margin:0 0 0 10px">{{ d_info.description || "" }}</p>
          </div>
          <div style="height: 1px;margin: 6px 0;background: #409EFF"></div>
          <p style="font-size:20px;font-weight:bold;margin-top:5px;margin-bottom:5px">空间预约关联主商品</p>
          <el-table
              :data="d_info.skuList"
              border
              size="small"
              style="width:98%;margin-top:5px;font-size:13px;"
              :header-cell-style="{'text-align':'center','background':'#f4f4f4','color':'#0dA7C8'}"
              :cell-style="tableYs">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="orderSkuName" label="商品名称" min-width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="skuName" label="商品规格" min-width="90" show-overflow-tooltip></el-table-column>
            <el-table-column label="商品定价" width="90" align="center">
              <template slot-scope="scope">¥{{ scope.row.moneySkuPrice.toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="number" label="购买数量" width="90" align="center"></el-table-column>
            <el-table-column label="小计" width="90" align="center">
              <template slot-scope="scope">¥{{ (scope.row.moneySkuPrice * scope.row.number).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column prop="goodsId" label="商品ID" width="150" align="center"></el-table-column>
          </el-table>
          <div style="display: flex;align-items: center;margin-top:10px">
            <el-button @click="onKeepTk" type="primary" v-if="d_info.orderStatusId===4">确定退款</el-button>
          </div>
        </div>
        <!--        <div
                    style="width:40%;background:#FFFFFF;margin:0 0.5%;display: flex;flex-flow: column;padding-left:15px;padding-bottom:20px;">
                  <p style="font-size:20px;font-weight:bold;margin-top:10px;margin-bottom:5px">操作记录</p>
                  <el-table :data=fil_tabData2 class="tab_orderSon" :cell-style="tableYs" border
                            style="width:98%; margin-left:1px;font-size:13px; background:#FFFFFF;margin-top:1px"
                            show-overflow-tooltip
                            ref="multipleTable"
                            :header-cell-style="{ 'height': '30px', 'text-align': 'center', 'background': '#f4f4f4', 'color': '#0dA7C8' }">
                    <el-table-column width="1">
                    </el-table-column>
                    <div v-for="(d, item) in this.defHead1">
                      <el-table-column v-if="d.val === 'skuName' || d.val === 'skuCode'" :label=d.key :width="d.w">
                        <template slot-scope="scope">
                          <p style="color:#72767b;font-size: 16px;width:80%">{{ scope.row[d.val] }}</p>
                        </template>
                      </el-table-column>
                      <el-table-column v-else :label=d.key :width="d.w">
                        <template slot-scope="scope">
                          <p style="color:#72767b;font-size: 16px;width:80%">{{ scope.row[d.val] }}</p>
                        </template>
                      </el-table-column>
                    </div>
                  </el-table>
                </div>-->
      </div>
    </el-card>
  </div>
</template>

<script>
import vueCropper from "../views/vueCropper.vue";

export default {
  name:'orderListSon',
  components:{
    vueCropper
  },
  props:{
    // 可通过外部传入当前步骤（0开始：0=待支付，1=待使用，2=已核销...）
    currentStep:{
      type:Number,
      default:0 // 默认当前步骤为「待使用」
    }
  },
  data() {
    return {
      isCtr:true,
      h_text:"预约订单详情",
      id:0,
      liState:[],
      activeStep:this.currentStep,
      d_info:{
        orderStatusId:0,
        moneySkuPrice:0,
        skuList:[]
      },
      liLog:[],
      defHead1:[
        {'key':"操作人",'val':"userName","w":"100px",'childData':[]},
        {'key':"操作内容",'val':"txt","w":"200px",'childData':[]},
        {'key':"操作时间",'val':"uptime","w":"150px",'childData':[]},
        {'key':"备注内容",'val':"bz","w":"auto",'childData':[]}
      ]
    };
  },
  methods:{
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    onBack() {
      if (this.isCtr) {
        this.isCtr = false;
        this.$router.go(-1);
        setTimeout(() => {
          this.isCtr = true;
        },1000);
      } else {
        this.$message.info('处理中，请勿频繁点击');
      }
    },
    onKeepTk() {
      this.$confirm('确定要退款吗？','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        type:'warning'
      }).then(() => {
        const params = {
          out_trade_no:this.id,
          projectId:localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        console.log(params);
        this.$api.post(this.$urls.ip + this.$urls.refund,params,headers).then(res => {
          console.log("refund",res.data.data);
          if (res.data.data) {
            this.$message.success("操作成功");
          }
          this.getUserOrder();
        }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error(error);
          } else {
            this.$message.error("操作失败");
          }
        });
      }).catch(() => {
        // 用户点击取消，不做任何操作
      });
    },
    copyOrderInfo() {
      const info = `【基本订单信息】
订单编号：${this.d_info.id || ''}
订单类型：${this.d_info.orderTypeName || ''}
订单状态：${this.d_info.orderStatusName || ''}
订单空间：${this.d_info.roomName || ''}
下单时间：${this.d_info.times || ''}
支付流水号：${this.d_info.transactionId || ''}
手机号：${this.d_info.phoneNumber || ''}
订单金额：¥${this.d_info.money ? this.d_info.money.toFixed(2):'0.00'}
实付金额：¥${this.d_info.moneyPaid ? this.d_info.moneyPaid.toFixed(2):'0.00'}

【用户信息】
用户名称：${this.d_info.userName || ''}
手机号码：${this.d_info.phoneNumber || ''}

【预约信息】
预约单号：${this.d_info.appId || ''}
预约空间：${this.d_info.roomName || ''}
预约时间：${this.d_info.appTime || ''}
预约备注：${this.d_info.description || ''}

【商品信息】
商品名称：${this.d_info.orderSkuName || ''}
商品定价：¥${this.d_info.moneySkuPrice ? this.d_info.moneySkuPrice.toFixed(2):'0.00'}
购买数量：${this.d_info.number || ''}
累计金额：¥${this.d_info.money ? this.d_info.money.toFixed(2):'0.00'}
商品ID：${this.d_info.goodsId || ''}`;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(info).then(() => {
          this.$message.success('订单信息已复制到剪贴板');
        }).catch(() => {
          this.fallbackCopy(info);
        });
      } else {
        this.fallbackCopy(info);
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success('订单信息已复制到剪贴板');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(textarea);
    },
    getOrderStatusList() {
      const params = {
        page:1,
        pageSize:30,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getOrderStatusList,params,headers).then(res => {
        console.log("getOrderStatusList",res.data.data);
        let li_d = res.data.data.list;
        this.total = li_d.length;
        if (li_d && li_d.length > 0) {
          let l = [];
          for (let i = 0; i < li_d.length; i++) {
            let d = {label:li_d[i]["name"],value:li_d[i]['id']};
            if (d['value'] < this.d_info['orderStatusId']) {
              d['icon'] = 'icon1';
            } else if (d['value'] === this.d_info['orderStatusId']) {
              d['icon'] = 'icon2';
            } else {
              d['icon'] = 'icon0';
            }
            d['description'] = ""; /*描述*/
            l.push(d);
          }
          this.liState = l;
        } else {
          this.liState = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取商品信息失败");
        }
      });
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes());
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m;
    },
    initOrder(d) {
      let d_d = {
        id:d['id'],
        orderStatusId:d['orderStatusId'], /*订单状态Id*/
        orderTypeName:"", /*订单类型*/
        orderStatusName:d['orderStatus']['name'], /*订单状态*/
        tradeState:d['orderStatus']['description'], /*微信支付状态*/
        transactionId:d['transactionId'], /*微信支付订单号*/
        money:d['money'] / 100, /*金额*/
        moneyPaid:d['realMoney'] / 100, /*实付金额*/
        moneySkuPrice:d['money'] / 100, /*商品定价*/
        goodsId:"", /*商品id*/
        orderSkuName:"", /*商品名称*/
        number:0, /*商品个数*/
        roomName:"", /*空间名称*/
        userName:"", /*客户名称*/
        phoneNumber:"", /*客户手机号*/
        appTime:"", /*预约时间*/
        description:d['description'], /*预约备注*/
        appId:"", /*预约单号*/
        times:this.timestampToTime(d['timestamp'] * 1000)
      };
      let skuList = [];
      if (d['orderSku'] && d['orderSku'].length > 0) {
        d['orderSku'].forEach(item => {
          if (item['goodsSku'] && item['goodsSku']['goods']) {
            let skuItem = {
              orderSkuName:item['goodsSku']['goods']['name'] || '',
              skuName:item['goodsSku']['skuName'] || '',
              goodsId:item['goodsSku']['goodsId'] || '',
              number:item['skuNum'] || 0,
              moneySkuPrice:0
            };
            if (item['goodsSku']['skuPrice'] && item['goodsSku']['skuPrice'][0]) {
              skuItem.moneySkuPrice = item['goodsSku']['skuPrice'][0]['price'] / 100;
            }
            skuList.push(skuItem);
          }
        });
      }
      d_d['skuList'] = skuList;
      // Keep first item for backward compatibility
      if (skuList.length > 0) {
        d_d['number'] = skuList[0].number;
        d_d['goodsId'] = skuList[0].goodsId;
        d_d['orderSkuName'] = skuList[0].orderSkuName;
        d_d['moneySkuPrice'] = skuList[0].moneySkuPrice;
      }

      if (d['orderType']) {
        d_d["orderTypeName"] = d['orderType']['name']; /*订单类型*/
      }
      if (d['appoint']) {
        //d_d['moneyPaid'] = d['appoint']['money']; /*预约金额*/
        let devArea = "";
        let d_r = d['appoint'];
        if (d_r['room']) {
          devArea = d_r['room']['name'];
          if (d_r['room']['floor']) {
            devArea = d_r['room']['floor']['name'] + "-" + d_r['room']['name'];
            if (d_r['room']['floor']['building']) {
              devArea = d_r['room']['floor']['building']['name'] + "-" + d_r['room']['floor']['name'] + "-" + d_r['room']['name'];
            }
          }
        } else if (d_r['floor']) {
          devArea = d_r['floor']['name'];
          if (d_r['floor']['building']) {
            devArea = d_r['floor']['building']['name'] + "-" + d_r['floor']['name'];
          }
        }
        if (d['appoint']['name'] !== devArea) {
          d_d['roomName'] = `${d['appoint']['name']}-${devArea}`;
        } else {
          d_d['roomName'] = `${d['appoint']['name']}`;
        }
        d_d["appId"] = `${d['appoint']["id"]}`;
        d_d["appTime"] = `${d['appoint']["beginExpDate"]} - ${d['appoint']["endExpDate"]}`;
      }
      if (d["user"]) {
        if (d['user']['phoneNumber']) {
          d_d["phoneNumber"] = d['user']['phoneNumber'];
        } else {
          d_d["phoneNumber"] = d['user']['applyNumber'];
        }
        if (d['user']['name']) {
          d_d["userName"] = d['user']['name'];
        } else if (d['user']["nickName"]) {
          d_d['userName'] = d['user']["nickName"];
        } else if (d['user']["userName"]) {
          d_d['userName'] = d["userName"];
        }
      } else {
        if (d["customNumber"]) { /*手机号*/
          d_d['phoneNumber'] = d["customNumber"];
        }
        if (d["name"]) { /*用户名*/
          d_d['userName'] = d["name"];
        } else if (d["nickName"]) {
          d_d['userName'] = d["nickName"];
        } else if (d["userName"]) {
          d_d['userName'] = d["userName"];
        }
      }
      this.d_info = d_d;
      this.activeStep = d_d['orderStatusId'] - 1;
      this.getOrderStatusList();
    },
    getUserOrder() {
      const params = {
        id:this.id,
        projectId:localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getUserOrder,params,headers).then(res => {
        console.log("getUserOrder",res.data.data);
        let d_data = res.data.data.data;
        if (d_data) {
          this.initOrder(d_data);
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error(error);
        } else {
          this.$message.error("获取订单信息失败");
        }
      });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    console.log("id",this.id);
    this.getUserOrder();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData2() {
      return this.liLog.filter(item => {
        this.state = true;
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/
    currentStep(newVal,oldVal) {
      this.activeStep = newVal;
    }
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style scoped>
.orderListSon {
  height: 94vh;
  padding: 20px;
  overflow-y: auto;
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}

/* 确保所有文本内容均可鼠标选中 */
.orderListSon * {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}

/* 自定义Steps整体样式 */
.custom-steps {
  --el-steps-process-text-color: #1677ff; /* 当前步骤文字颜色 */
  --el-steps-finish-text-color: #1677ff; /* 已完成步骤文字颜色 */
  --el-steps-wait-text-color: #999; /* 未完成步骤文字颜色 */
  --el-steps-finish-border-color: #1677ff; /* 已完成步骤边框颜色 */
  --el-steps-finish-bg-color: #1677ff; /* 已完成步骤背景色 */
  --el-steps-process-border-color: #1677ff; /* 当前步骤边框颜色 */
  --el-steps-process-bg-color: #1677ff; /* 当前步骤背景色 */
  --el-steps-wait-border-color: #e5e7eb; /* 未完成步骤边框颜色 */
  --el-steps-wait-bg-color: #fff; /* 未完成步骤背景色 */
  --el-steps-line-color: #e5e7eb; /* 未激活线条颜色 */
  --el-steps-finish-line-color: #1677ff; /* 已激活线条颜色 */
}

/* 步骤项样式 */
.step-item {
  .el-step__icon {
    width: 50px;
    height: 24px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 自定义图标：勾（已完成） */

  .icon-check::before {
    content: "✓";
    font-size: 25px;
  }

  .icon0 {
    content: "";
    width: 25px;
    height: 25px;
    background: url("../../assets/order/yuan0.png") center no-repeat;
    background-size: 100% 100%;
  }

  .icon1 {
    content: "";
    width: 25px;
    height: 25px;
    background: url("../../assets/order/yuan1.png") center no-repeat;
    background-size: 100% 100%;
  }

  .icon2 {
    content: "";
    width: 25px;
    height: 25px;
    background: url("../../assets/order/yuan2.png") center no-repeat;
    background-size: 100% 100%;
  }

  /* 当前步骤的图标文字颜色 */

  &.current-step .el-step__icon {
    color: #1677ff;
  }

  /* 未完成步骤的图标文字颜色 */

  .el-step__icon.is-wait {
    color: #e5e7eb;
  }
}

/* 步骤下方的时间文本 */
.step-time {
  font-size: 12px;
  color: #333;
  margin-top: 4px;
}

/* 调整步骤标题位置，更贴近截图样式 */
.el-step__title {
  margin-top: 8px !important;
  font-size: 14px !important;
}

.tab_orderSon {
  user-select: text;

  .gutter {
    /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important;
    /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/orderListSon.vue